import React, { ReactNode } from "react"

import { FieldArrayFieldsProps, WrappedFieldArrayProps } from "redux-form/lib/FieldArray"
import { TitledLink } from "../../../types"
import { Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { FormattedMessage } from "react-intl"

type Props<T extends TitledLink> = {
  children: (name: string, field: T, index: number, fields: FieldArrayFieldsProps<T>) => ReactNode
  suffix?: ReactNode
  createNew?: () => T
} & WrappedFieldArrayProps<T>

export const LinksContainer = <T extends TitledLink>({
  fields,
  children,
  suffix,
  createNew,
}: Props<T>) => (
  <>
    {Boolean(fields.length) && (
      <>
        <ul className="link-fields-container">
          {fields.map((name, index) => {
            const { url, title } = fields.get(index)
            return (
              <li key={`${url}_${title}_${index}`} className="fade-in-down">
                {children(name, fields.get(index), index, fields)}
              </li>
            )
          })}
        </ul>
        {suffix}
      </>
    )}
    {createNew && (
      <div className="row center-xs">
        <Button onClick={() => fields.push(createNew())}>
          <PlusOutlined /> <FormattedMessage id="form.step.addLinks.button.addField" />
        </Button>
      </div>
    )}
  </>
)
